/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SmyFullPopup.vue?vue&type=template&id=3c1e545e&scoped=true&"
import script from "./SmyFullPopup.vue?vue&type=script&lang=js&"
export * from "./SmyFullPopup.vue?vue&type=script&lang=js&"
import style0 from "./SmyFullPopup.vue?vue&type=style&index=0&id=3c1e545e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e545e",
  null
  
)

export default component.exports